import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import recordReducer from './recordReducer';
import recordListReducer from './recordListReducer';
import vinCheckReducer from './vinCheckReducer';
import storage from '../storage/indexedDbStorage';
import { reduxDataBases } from '../../config';

const vinCheckPersistConfig = {
  key: 'vinCheck',
  storage: storage(reduxDataBases.vincheck),
};

const rootReducer = combineReducers({
  reduxRecords: recordReducer,
  reduxVincheck: vinCheckReducer,
  recordList: recordListReducer,
  // add others reducers
});

export default persistReducer(vinCheckPersistConfig, rootReducer);
